import { render, staticRenderFns } from "./contractReviewList.vue?vue&type=template&id=36a01b6e"
import script from "./contractReviewList.vue?vue&type=script&lang=js"
export * from "./contractReviewList.vue?vue&type=script&lang=js"
import style0 from "./contractReviewList.vue?vue&type=style&index=0&id=36a01b6e&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports